var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{style:(_vm.getCustomButtonStyle),attrs:{"id":"searchButton","dark":"","depressed":""},on:{"click":_vm.searchProperties}},[_vm._v("\n  Go\n")])}
var staticRenderFns = []

export { render, staticRenderFns }